import { useEffect } from 'react'
import { useProjectStore } from './use-project-store'
import { useCurrentUser } from './use-current-user'

export function useAiCodingMonitor() {
  const { getUserMessages, project } = useProjectStore()

  const userMessages = getUserMessages()

  const { data: user } = useCurrentUser()

  const getLastUserMessage = () => {
    return userMessages?.[userMessages.length - 1]?.content
  }

  const getErrorMessage = (error: Error | string | undefined) => {
    if (error instanceof Error) {
      return error.message
    }
    if (typeof error === 'object' && error !== null) {
      try {
        return JSON.stringify(error)
      } catch (error) {
        return 'stringify error'
      }
    }
    if (typeof error === 'string') {
      return error
    }
    return 'unknown'
  }

  const monitorLoadFailure = (
    error: Error | string | undefined,
    extra?: Record<string, string>,
  ) => {
    console.error(
      `[Failed to load] AI coding need to fix issue: ${getErrorMessage(error)}`,
      {
        extra: {
          projectId: project?._id?.toString(),
          userId: user?._id?.toString(),
          lastUserMessage: getLastUserMessage(),
          ...extra,
        },
      },
    )
  }

  const monitorResponseFailure = (
    requestId: string,
    error: Error | string | undefined,
    extra?: Record<string, string>,
  ) => {
    console.error(
      `[Failed to response] (${requestId}) AI coding need to fix issue: ${getErrorMessage(error)}`,
      {
        extra: {
          requestId,
          projectId: project?._id?.toString(),
          userId: user?._id?.toString(),
          lastUserMessage: getLastUserMessage(),
          ...extra,
        },
      },
    )
  }

  useEffect(() => {
    const handleError = (error: Error) => {
      console.error('AI coding error:', error)
    }

    const handleMessage = (message: string) => {
      console.log('AI coding message:', message)
    }

    return () => {
      // Cleanup if needed
    }
  }, [])

  return {
    monitorLoadFailure,
    monitorResponseFailure,
  }
}
